/* PRISKEL · Pre-order in weekly batches. Sits on top of pk-product.js and pk-cart.js without changing them.
   Config: <script id="pk-po-cfg" type="application/json"> from sections/pk-cart.liquid
     { on, cycle, anchor:"YYYY-MM-DD", mk:[min,max], sh:[min,max], split, pv, ut, live:[ids], soon:[ids] }
   How a date is worked out (all in IST):
     batch close  = the next batch day on or after today (anchor + n x cycle). Orders until 23:59 that day join it.
     arrives      = close + making(min..max) + checks & shipping(min..max)
   The date a customer sees when they order is written onto their order line and never moves later,
   whoever orders after them. The next batch simply gets the next date. */
(function () {
  if (window.PKPO) return;
  var el = document.getElementById('pk-po-cfg');
  var cfg = {};
  try { cfg = JSON.parse(el ? el.textContent : '{}'); } catch (e) { cfg = {}; }
  if (cfg.on === false) return;
  var CYCLE = Math.max(1, +cfg.cycle || 7);
  var MK = cfg.mk || [20, 30], SH = cfg.sh || [3, 6];
  var role = window.Shopify && Shopify.theme && Shopify.theme.role;
  var preview = !!cfg.pv && !!role && role !== 'main';
  if (preview) document.documentElement.classList.add('pk-po-pv');

  var MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var DAY = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var DMS = 864e5;
  function istNow() { var d = new Date(); return new Date(d.getTime() + (d.getTimezoneOffset() + 330) * 60000); }
  function day0(d) { return new Date(d.getFullYear(), d.getMonth(), d.getDate()); }
  function add(d, n) { var x = new Date(d.getTime()); x.setDate(x.getDate() + n); return x; }
  function iso(d) { return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2); }
  function dm(d) { return d.getDate() + ' ' + MON[d.getMonth()]; }
  function ddm(d) { return DAY[d.getDay()] + ' ' + dm(d); }
  function range(a, b) { return a.getMonth() === b.getMonth() ? a.getDate() + '–' + b.getDate() + ' ' + MON[b.getMonth()] : dm(a) + ' – ' + dm(b); }

  var NOW = istNow(), TODAY = day0(NOW);
  var A = /^\d{4}-\d{2}-\d{2}$/.test(cfg.anchor || '') ? cfg.anchor.split('-') : null;
  var ANCH = A ? new Date(+A[0], +A[1] - 1, +A[2]) : add(TODAY, (7 - TODAY.getDay()) % 7); /* default: Sundays */
  var k = Math.ceil(Math.round((TODAY - ANCH) / DMS) / CYCLE);
  var CLOSE = add(ANCH, k * CYCLE);
  while (CLOSE < TODAY) CLOSE = add(CLOSE, CYCLE);
  while (add(CLOSE, -CYCLE) >= TODAY) CLOSE = add(CLOSE, -CYCLE);
  var FROM = add(CLOSE, +MK[0] + +SH[0]), BY = add(CLOSE, +MK[1] + +SH[1]);
  var LEFT = Math.round((CLOSE - TODAY) / DMS); /* 0 = closes tonight */
  var D = {
    close: ddm(CLOSE), span: range(FROM, BY), by: dm(BY), byx: 'by ' + dm(BY), byd: ddm(BY),
    left: LEFT === 0 ? 'closes tonight' : LEFT === 1 ? 'closes tomorrow' : LEFT + ' days left',
    weeks: Math.round((BY - TODAY) / DMS / 7)
  };

  var IC = '<svg class="pk-po-ic" viewBox="0 0 24 24" aria-hidden="true"><path d="M6.5 3h11M6.5 21h11M7.5 3c0 4.6 4.5 6 4.5 9s-4.5 4.4-4.5 9M16.5 3c0 4.6-4.5 6-4.5 9s4.5 4.4 4.5 9"/><path d="M10 18.2h4" opacity=".7"/></svg>';
  function inr(p) { return '₹' + Math.round(p / 100).toLocaleString('en-IN'); }
  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return [].slice.call((c || document).querySelectorAll(s)); }

  /* dates anywhere on the page: <span data-pk-po-date="by|span|close|left">fallback</span> */
  function paintDates(root) { $$('[data-pk-po-date]', root).forEach(function (n) { var k2 = n.getAttribute('data-pk-po-date') || 'by'; n.textContent = D[k2] || D.by; }); }
  paintDates(document);

  var live = {}, soon = {};
  (cfg.live || []).forEach(function (id) { live[id] = 1; });
  (cfg.soon || []).forEach(function (id) { soon[id] = 1; });
  function isPO(id) { return !!live[id] || (preview && !!soon[id]); }

  /* ---------------- product page ---------------- */
  function pdp(sec) {
    if (sec.__po) return; sec.__po = 1;
    var data = { variants: [] };
    try { data = JSON.parse($('[data-pkp-json]', sec).textContent); } catch (e) {}
    var byId = {}; data.variants.forEach(function (v) { byId[v.id] = v; });
    var idInput = $('[data-pkp-id]', sec);
    var busy = false;
    var guar = cfg.ut ? '6-month Finish Promise' : 'Lifetime Colour Guarantee';
    function panel(v) {
      var held = v && v.qty < 0 ? -v.qty : 0;
      return '<div class="pk-po-pd" data-pk-po-panel>' +
        '<div class="pk-po-pd__hd"><span class="pk-po-pd__badge">' + IC + '</span><div>' +
        '<span class="pk-po-pd__ey">Pre-order · this week’s batch</span>' +
        '<span class="pk-po-pd__t">Sold out, but not gone.</span>' +
        '<p class="pk-po-pd__s">Reserve yours in this week’s batch. It is made for you and arrives <b>' + D.span + '</b>.</p>' +
        (held >= 2 ? '<p class="pk-po-pd__held"><i aria-hidden="true"></i>' + held + ' already reserved</p>' : '') +
        '</div></div>' +
        '<ol class="pk-po-pd__tl" aria-label="What happens next">' +
        '<li class="is-on"><i></i><b>Today</b><span>Reserved, price locked</span></li>' +
        '<li><i></i><b>' + D.close + '</b><span>Batch closes, goes into making</span></li>' +
        '<li><i></i><b>Checked</b><span>Every piece, before it ships</span></li>' +
        '<li class="is-end"><i></i><b>' + D.span + '</b><span>At your door</span></li>' +
        '</ol>' +
        '<div class="pk-po-pd__pr"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3l7 3v5c0 4.6-3 8.5-7 10-4-1.5-7-5.4-7-10V6z"/><path d="M8.8 12.2l2.2 2.2 4.4-4.6"/></svg>' +
        '<p><b>The pre-order promise.</b> Change your mind before ' + D.close + ' and cancel free. If it is not with you by ' + D.byd + ', cancel for a full refund.</p></div>' +
        '<p class="pk-po-pd__f"><span>Same price</span><span>' + guar + '</span><span>Free shipping</span></p>' +
        '</div>';
    }
    function apply() {
      if (busy) return; busy = true;
      var v = idInput && byId[+idInput.value];
      var on = !!(v && isPO(v.id));
      var pv = on && !live[v.id];
      sec.classList.toggle('is-po', on);
      sec.classList.toggle('is-po-pv', pv);
      /* pills */
      var opts = $$('[data-pkp-opt]', sec);
      var sel = opts.map(function (o) { var b = $('.pk-pd__pill.is-on', o); return b ? b.getAttribute('data-val') : null; });
      opts.forEach(function (o, oi) {
        $$('.pk-pd__pill', o).forEach(function (b) {
          var t = sel.slice(); t[oi] = b.getAttribute('data-val');
          var m = null; data.variants.forEach(function (x) { if (x.options.every(function (y, j) { return y === t[j]; })) m = x; });
          var p = !!(m && isPO(m.id));
          b.classList.toggle('is-po', p);
          if (p) b.title = 'Pre-order · arrives ' + D.span; else if (b.title && /^Pre-order/.test(b.title)) b.removeAttribute('title');
        });
      });
      var stock = $('[data-pkp-stock]', sec);
      var atc = $('[data-pkp-atc]', sec), lab = $('[data-pkp-atcl]', sec);
      var eta = $('[data-pkp-eta]', sec);
      var note = $('[data-pk-po-note]', sec);
      if (on) {
        var cur = $('[data-pk-po-panel]', stock || sec);
        if (stock && (!cur || cur.getAttribute('data-v') != v.id)) {
          stock.innerHTML = panel(v);
          var p = $('[data-pk-po-panel]', stock); p.setAttribute('data-v', v.id);
          requestAnimationFrame(function () { requestAnimationFrame(function () { p.classList.add('is-in'); }); });
        }
        if (lab) {
          var m2 = /Add (\d+) to bag(.*)$/.exec(lab.textContent);
          var txt = m2 ? 'Pre-order ' + m2[1] + m2[2] : 'Pre-order · ' + inr(v.price);
          if (lab.getAttribute('data-po') !== txt || !lab.querySelector('svg')) { lab.innerHTML = IC + '<span>' + txt + '</span>'; lab.setAttribute('data-po', txt); }
        }
        if (atc) { if (pv) atc.setAttribute('aria-disabled', 'true'); else atc.removeAttribute('aria-disabled'); }
        if (eta && (eta.getAttribute('data-po') !== D.span || eta.textContent.indexOf('Pre-order') !== 0)) {
          if (eta.textContent.indexOf('Pre-order') !== 0) eta.__orig = eta.innerHTML;
          eta.innerHTML = 'Pre-order · arrives <b>' + D.span + '</b>'; eta.setAttribute('data-po', D.span);
        }
        if (!note && atc) {
          note = document.createElement('p'); note.className = 'pk-po-pd__note'; note.setAttribute('data-pk-po-note', '');
          var btns = atc.closest('.pk-pd__btns') || atc; btns.parentNode.insertBefore(note, btns.nextSibling);
        }
        if (note) note.innerHTML = pv
          ? '<span class="pk-po-pd__pv">Preview: pre-orders open for this piece once it goes live.</span>'
          : '<span class="pk-po-pd__clk"><i aria-hidden="true"></i>This batch closes <b>' + D.close + '</b> · ' + D.left + '</span>';
      } else {
        if (stock && $('[data-pk-po-panel]', stock) && v) stock.innerHTML = v.available ? '' : '<div class="pk-pd__av is-out"><i class="pk-pd__sdot" aria-hidden="true"></i><p><b>Sold out</b> · back soon</p></div>';
        if (lab && lab.getAttribute('data-po')) { lab.removeAttribute('data-po'); lab.textContent = !v || !v.available ? 'Sold out' : 'Add to bag · ' + inr(v.price); }
        if (eta && eta.getAttribute('data-po')) { eta.removeAttribute('data-po'); if (eta.__orig) eta.innerHTML = eta.__orig; }
        if (note) note.remove();
      }
      busy = false;
    }
    /* pk-product.js rewrites the label, stock line and delivery line on every change: follow it */
    if (window.MutationObserver) {
      var mo = new MutationObserver(function () { if (!busy) setTimeout(apply, 0); });
      ['[data-pkp-atcl]', '[data-pkp-stock]', '[data-pkp-eta]'].forEach(function (s) { var n = $(s, sec); if (n) mo.observe(n, { childList: true, characterData: true, subtree: true }); });
      if (idInput) mo.observe(idInput, { attributes: true, attributeFilter: ['value'] });
    }
    sec.addEventListener('click', function (e) { if (e.target.closest('.pk-pd__pill, [data-pkp-tier], [data-pkp-pick]')) setTimeout(apply, 0); });
    sec.addEventListener('change', function () { setTimeout(apply, 0); });
    apply();
  }

  /* ---------------- write the batch and promised dates onto the order line ---------------- */
  function props() {
    return { 'Pre-order': 'Arrives ' + D.span + ' ' + BY.getFullYear(), '_pk_batch': iso(CLOSE), '_pk_by': iso(BY) };
  }
  function tagItems(items) {
    var hit = false;
    (items || []).forEach(function (it) { if (it && live[+it.id]) { it.properties = Object.assign({}, it.properties || {}, props()); hit = true; } });
    return hit;
  }
  if (window.fetch && (cfg.live || []).length) {
    var of = window.fetch;
    window.fetch = function (u, o) {
      try {
        var url = typeof u === 'string' ? u : (u && u.url) || '';
        if (/\/cart\/add(\.js)?(\?|$)/.test(url) && o && o.body) {
          if (typeof o.body === 'string') {
            var b = JSON.parse(o.body);
            if (b.items ? tagItems(b.items) : tagItems([b])) { o = Object.assign({}, o, { body: JSON.stringify(b) }); }
          } else if (window.FormData && o.body instanceof FormData) {
            var id = +o.body.get('id');
            if (live[id]) { var pp = props(); Object.keys(pp).forEach(function (k) { o.body.set('properties[' + k + ']', pp[k]); }); }
          }
        }
      } catch (e) {}
      return of.call(this, u, o);
    };
  }
  /* plain form posts (no-JS fallbacks) */
  document.addEventListener('submit', function (e) {
    var f = e.target; if (!f || !/\/cart\/add/.test(f.getAttribute('action') || '')) return;
    var idf = f.querySelector('[name="id"]'); if (!idf || !live[+idf.value]) return;
    var pp = props();
    Object.keys(pp).forEach(function (k) { var n = f.querySelector('[name="properties[' + k + ']"]'); if (!n) { n = document.createElement('input'); n.type = 'hidden'; n.name = 'properties[' + k + ']'; f.appendChild(n); } n.value = pp[k]; });
  }, true);

  /* ---------------- bag ---------------- */
  var bagBusy = false, lastSig = '';
  function decorateBag() {
    var body = $('[data-pk-c-body]'); if (!body || bagBusy) return;
    bagBusy = true;
    fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      var po = 0, inStock = 0, last = '';
      (c.items || []).forEach(function (it) {
        var pr = it.properties || {}, t = pr['Pre-order'];
        if (!t) { inStock++; return; }
        po++; last = String(t).replace(/^Arrives\s*/i, '').replace(/\s\d{4}$/, '');
        var li = body.querySelector('.pk-cart__it[data-key="' + (window.CSS && CSS.escape ? CSS.escape(it.key) : it.key) + '"]');
        if (!li || li.querySelector('.pk-cart__po')) return;
        var v = li.querySelector('.pk-cart__it-v') || li.querySelector('.pk-cart__it-t');
        var s = document.createElement('span'); s.className = 'pk-cart__po';
        s.innerHTML = IC + 'Pre-order · arrives ' + last;
        v.parentNode.insertBefore(s, v.nextSibling);
      });
      var n = body.querySelector('[data-pk-po-bag]');
      if (po && !n) {
        n = document.createElement('p'); n.className = 'pk-cart__ponote'; n.setAttribute('data-pk-po-bag', '');
        var list = body.querySelector('.pk-cart__it'); list = list ? list.parentNode : null;
        if (list) list.parentNode.insertBefore(n, list.nextSibling); else body.appendChild(n);
      }
      if (n && po) {
        var msg = '<b>Your pre-order arrives ' + last + '.</b> ' +
          (inStock ? (cfg.split === false ? 'Everything travels together, in one parcel, when it is ready.' : 'Pieces in stock ship now, on their own. Shipping stays free on both.') : 'You can cancel free until the batch closes on ' + D.close + '.');
        n.innerHTML = IC + '<span>' + msg + '</span>';
      } else if (!po && n) n.remove();
      bagBusy = false;
    }).catch(function () { bagBusy = false; });
  }
  function watchBag() {
    var body = $('[data-pk-c-body]'); if (!body || !window.MutationObserver) return;
    var t = null;
    new MutationObserver(function () {
      var sig = $$('.pk-cart__it', body).map(function (x) { return x.getAttribute('data-key') + (x.querySelector('.pk-cart__po') ? '1' : '0'); }).join(',');
      if (sig === lastSig) return; lastSig = sig;
      clearTimeout(t); t = setTimeout(decorateBag, 60);
    }).observe(body, { childList: true, subtree: true });
  }

  function run() { $$('[data-pkp]').forEach(pdp); paintDates(document); }
  window.PKPO = { dates: D, close: iso(CLOSE), by: iso(BY), isPO: isPO, preview: preview };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { run(); watchBag(); }); else { run(); watchBag(); }
  document.addEventListener('shopify:section:load', run);
})();
